import { batch } from 'react-redux';
import { IAllCommandMenus } from 'src/common/interfaces/dtos/IAllCommandMenus';
import { ITabs } from 'src/common/interfaces/dtos/ITabs';
import { IPosUiMenu } from 'src/common/interfaces/states/IPosUiMenuState';
import { store } from 'src/common/redux/configure-store';
import { CommandMenuActions } from 'src/common/redux/reducers/command-menu-reducer';
import { PosUiMenuActions } from 'src/common/redux/reducers/pos-ui-menu-reducer';
import { TabMenuActions } from 'src/common/redux/reducers/tab-menu-reducer';
import {
  defaultCommandMenu,
  defaultFocusMenu,
  defaultInfoMenu,
  defaultPopularMenu,
  defaultTabs,
  defaultUserMenu,
} from 'src/pos-configuration/default-command-menus';
import { EmeraldError } from '../common/api/emerald-error';
import XLRLogger from '../common/helpers/logger';
import { ICommandGroupMap } from '../common/interfaces/dtos/ICommandsGroup';
import { popupMessage } from '../messages/business-logic/popup-message';
import { getCommandMenuConfig } from './service/get-command-menu-config';

export const getAllCommandMenus = async (): Promise<void> => {
  return getCommandMenuConfig()
    .then(setMenus)
    .catch(err => {
      XLRLogger.error({
        message: 'Failed to get command menu from BFF',
        data: err,
        source: 'get-command-menu',
      });
      setDefaultPosUiMenu();
      popupMessage(new EmeraldError('Get_Command_Menu_Failure'));
    });
};

const setDefaultPosUiMenu = () => setMenus({});

const setMenus = (allCommandMenu: IAllCommandMenus): void => {
  let { commandMenu, tabMenu, focusMenu, userMenu, infoMenu, popularMenu } = allCommandMenu;
  commandMenu = commandMenu || defaultCommandMenu;
  tabMenu = tabMenu || defaultTabs;
  focusMenu = focusMenu || defaultFocusMenu;
  userMenu = userMenu || defaultUserMenu;
  infoMenu = infoMenu || defaultInfoMenu;
  popularMenu = popularMenu || defaultPopularMenu;

  batch(() => {
    store.dispatch(CommandMenuActions.setCommands(commandMenu as ICommandGroupMap));
    store.dispatch(TabMenuActions.setTabs(tabMenu as ITabs));
    store.dispatch(PosUiMenuActions.set(focusMenu as IPosUiMenu));
    store.dispatch(PosUiMenuActions.set(userMenu as IPosUiMenu));
    store.dispatch(PosUiMenuActions.set(infoMenu as IPosUiMenu));
    store.dispatch(PosUiMenuActions.set(popularMenu as IPosUiMenu));
  });
};
